export const BIG_QUERY = 'OBS::BIG_QUERY';
